import { createIcon } from "@hopper-ui/icons";
import type { ComponentProps } from "react";

const Stethoscope32 = (props: ComponentProps<"svg">) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32" {...props}>
            <path d="M15.555 8.889V7.112a.89.89 0 0 1 1.778 0v1.777a.89.89 0 0 1-1.778 0M10.221 8.889V7.112a.89.89 0 0 1 1.779 0v1.777a.89.89 0 0 1-1.779 0" />
            <path d="M7.555 13.334V9.778A2.667 2.667 0 0 1 10.22 7.11h.89a.89.89 0 0 1 0 1.778h-.89a.89.89 0 0 0-.888.889v3.556a4.445 4.445 0 1 0 8.888 0V9.778a.887.887 0 0 0-.888-.889h-.889a.89.89 0 0 1 0-1.778h.89A2.67 2.67 0 0 1 20 9.778v3.556a6.222 6.222 0 0 1-12.445 0" />
            <path d="M12.888 18.667a.89.89 0 0 1 1.779 0 4.444 4.444 0 1 0 8.888 0V16a.89.89 0 0 1 1.778 0v2.667a6.222 6.222 0 0 1-12.445 0" />
            <path d="M25.332 14.222a.889.889 0 1 0-1.778.002.889.889 0 0 0 1.778-.002m1.777 0a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0" />
        </svg>
    );
};

const Stethoscope24 = (props: ComponentProps<"svg">) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
            <path d="M11.666 6.667V5.334a.667.667 0 0 1 1.334 0v1.333a.667.667 0 0 1-1.334 0M7.666 6.667V5.334a.667.667 0 0 1 1.334 0v1.333a.667.667 0 0 1-1.334 0" />
            <path d="M5.666 10V7.333a2 2 0 0 1 2-2h.667a.667.667 0 0 1 0 1.334h-.667A.666.666 0 0 0 7 7.333V10a3.333 3.333 0 1 0 6.666 0V7.333A.666.666 0 0 0 13 6.667h-.667a.667.667 0 0 1 0-1.334H13a2 2 0 0 1 2 2V10a4.667 4.667 0 0 1-9.334 0" />
            <path d="M9.666 14A.667.667 0 0 1 11 14a3.334 3.334 0 1 0 6.666 0v-2A.667.667 0 0 1 19 12v2a4.667 4.667 0 0 1-9.334 0" />
            <path d="M18.999 10.667a.667.667 0 1 0-1.333 0 .667.667 0 0 0 1.333 0m1.333 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0" />
        </svg>
    );
};

const Stethoscope16 = (props: ComponentProps<"svg">) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
            <path d="M7.777 4.444v-.888a.445.445 0 0 1 .89 0v.888a.445.445 0 0 1-.89 0M5.11 4.444v-.888a.445.445 0 0 1 .89 0v.888a.445.445 0 0 1-.89 0" />
            <path d="M3.777 6.667V4.889a1.334 1.334 0 0 1 1.334-1.334h.444a.445.445 0 0 1 0 .89h-.444a.444.444 0 0 0-.444.444v1.777a2.222 2.222 0 1 0 4.444 0V4.89a.444.444 0 0 0-.444-.445h-.445a.445.445 0 0 1 0-.889h.445A1.334 1.334 0 0 1 10 4.89v1.777a3.111 3.111 0 0 1-6.223 0" />
            <path d="M6.444 9.333a.445.445 0 0 1 .89 0 2.223 2.223 0 1 0 4.443 0V8a.445.445 0 0 1 .89 0v1.333a3.111 3.111 0 0 1-6.223 0" />
            <path d="M12.666 7.111a.444.444 0 1 0-.889 0 .444.444 0 0 0 .889 0m.889 0a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0" />
        </svg>
    );
};

export const StethoscopeIcon = createIcon(Stethoscope16, Stethoscope24, Stethoscope32, "StethoscopeIcon");
